var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("StatusBar", { attrs: { params: this.$route.query.params } }),
      _vm.personList.length > 0
        ? _c(
            "div",
            { staticClass: "tool-list" },
            [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v("共計：" + _vm._s(_vm.totalPerson) + "人"),
              ]),
              _c("CardStyle", { on: { changeStyle: _vm.changeStyle } }),
            ],
            1
          )
        : _vm._e(),
      _c("SearchBar", {
        attrs: { show: _vm.showSearchBar },
        on: {
          showSearchBar: function ($event) {
            _vm.showSearchBar = !_vm.showSearchBar
          },
          search: function ($event) {
            ;(_vm.currentPage = 1), _vm.getInterviewed()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "searchItem",
            fn: function () {
              return [
                _c("el-input", {
                  staticClass: "w-100 item-bottom",
                  attrs: {
                    clearable: "",
                    placeholder: "關鍵字（姓名、Email、聯絡電話）",
                  },
                  model: {
                    value: _vm.searchCondition.Keyword,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.searchCondition,
                        "Keyword",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "searchCondition.Keyword",
                  },
                }),
                _c("el-date-picker", {
                  staticClass: "w-100 item-bottom",
                  attrs: {
                    type: "daterange",
                    clearable: "",
                    "picker-options": {
                      disabledDate: _vm.$common.disabledDateAfterToday,
                    },
                    "range-separator": "-",
                    "start-placeholder": "面談日期(起)",
                    "end-placeholder": "面談日期(迄)",
                  },
                  model: {
                    value: _vm.searchCondition.InterviewDateRange,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchCondition, "InterviewDateRange", $$v)
                    },
                    expression: "searchCondition.InterviewDateRange",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "單位面試主管",
                    },
                    model: {
                      value: _vm.searchCondition.InterviewSupervisor,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchCondition,
                          "InterviewSupervisor",
                          $$v
                        )
                      },
                      expression: "searchCondition.InterviewSupervisor",
                    },
                  },
                  _vm._l(_vm.userOptions, function (supervisor) {
                    return _c("el-option", {
                      key: supervisor.Guid,
                      attrs: { label: supervisor.Name, value: supervisor.Name },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "HR 面試人員",
                    },
                    model: {
                      value: _vm.searchCondition.InterviewHR,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "InterviewHR", $$v)
                      },
                      expression: "searchCondition.InterviewHR",
                    },
                  },
                  _vm._l(_vm.userOptions, function (supervisor) {
                    return _c("el-option", {
                      key: supervisor.Guid,
                      attrs: { label: supervisor.Name, value: supervisor.Name },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      clearable: "",
                      placeholder: "應聘者狀態",
                    },
                    model: {
                      value: _vm.searchCondition.Status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "Status", $$v)
                      },
                      expression: "searchCondition.Status",
                    },
                  },
                  _vm._l(_vm.candidateStatusOptions, function (status) {
                    return _c("el-option", {
                      key: status.key,
                      attrs: { label: status.value, value: status.value },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: { clearable: "", placeholder: "是否已輸入成績" },
                    model: {
                      value: _vm.searchCondition.isWriteScore,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "isWriteScore", $$v)
                      },
                      expression: "searchCondition.isWriteScore",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "是", value: true } }),
                    _c("el-option", { attrs: { label: "否", value: false } }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "person-card-list",
          class: {
            "list-style": _vm.gridStyle == "list",
            "block-style": _vm.gridStyle == "block",
          },
        },
        _vm._l(_vm.personList, function (person, index) {
          return _c(
            "div",
            { key: index, staticClass: "person-card infinite-list-item" },
            [
              _c("PersonCard", {
                ref: "personCard",
                refInFor: true,
                attrs: { showCheckbox: true, person: person },
                on: { updatePersonList: _vm.updatePersonList },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "note",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickResumeNote(props)
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: {
                                  name: "color-picker-outline",
                                  fill: "#000",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "tag",
                      fn: function ({ props }) {
                        return [
                          _c("div", { staticClass: "result" }, [
                            _vm._v(_vm._s(props.ApprovalResult)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "middleContent",
                      fn: function ({ props }) {
                        return [
                          _c("table", [
                            _c("tr", [
                              _c("th", [_vm._v("應徵職務")]),
                              _c("td", [_vm._v(_vm._s(props.Position))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("面談時間")]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$common.dateTimeFormatter(
                                      props.InterviewDate
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("面談地點")]),
                              _c("td", [_vm._v(_vm._s(props.InterviewPlace))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("單位面試主管")]),
                              _c("td", [
                                _vm._v(_vm._s(props.InterviewSupervisor[0])),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("HR 面試人員")]),
                              _c("td", [_vm._v(_vm._s(props.InterviewHR[0]))]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "buttonGroup",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "el-dropdown",
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "el-dropdown-link",
                                  attrs: { type: "button" },
                                },
                                [
                                  _vm._v(" 檢視資訊"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showDetailModal(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視履歷 ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showProgressRecord(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視歷程 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickReinvite(props)
                                },
                              },
                            },
                            [_vm._v(" 重新邀約 ")]
                          ),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.openCommonModal({
                                    event: "singleScore",
                                    data: props,
                                  })
                                },
                              },
                            },
                            [_vm._v(" 輸入成績 ")]
                          ),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.getInterviewRecordHistory(
                                    props.MatchId
                                  )
                                },
                              },
                            },
                            [_vm._v(" 面談紀錄歷程 ")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm.personList.length > 0
        ? _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.totalPerson,
              "page-size": 9,
            },
            on: { "current-change": _vm.changePage },
          })
        : _vm._e(),
      _c("ActionBar", {
        attrs: {
          show: _vm.showActionBar,
          totalPerson: _vm.totalPerson,
          selectedCardList: _vm.choosePersonList,
        },
        on: {
          showActionBar: function ($event) {
            _vm.showActionBar = !_vm.showActionBar
          },
          selectAllCards: _vm.selectAllCards,
          clearSelectCard: _vm.clearSelectCard,
        },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function () {
              return [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.openCommonModal({ event: "batchScore" })
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "color-picker-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("批次輸入成績")]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("ResumeNoteModal", { attrs: { personData: _vm.personData } }),
      _c("ReinviteMailModal", {
        attrs: { personData: _vm.personData },
        on: { updatePerson: _vm.updatePerson },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "commonModal",
            "data-focus": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              class: _vm.modalEvent === "reason" ? null : "modal-xl",
            },
            [
              _c("ValidationObserver", {
                ref: "commonModal",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c(
                          "form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return handleSubmit(_vm.saveCommonModal)
                              },
                              reset: function ($event) {
                                $event.preventDefault()
                                return reset.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "modal-content" }, [
                              _c("div", { staticClass: "modal-header" }, [
                                _c("h5", { staticClass: "modal-title" }, [
                                  _vm._v(" " + _vm._s(_vm.modalTitle) + " "),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "modal-body" },
                                [
                                  _vm.modalEvent === "singleScore" ||
                                  _vm.modalEvent === "batchScore"
                                    ? [
                                        _c(
                                          "el-table",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              data: _vm.candidateScores,
                                              border: "",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                fixed: "",
                                                label: "姓名",
                                                height: "250",
                                                "min-width": "20%",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row.Name
                                                            ) +
                                                            "/" +
                                                            _vm._s(
                                                              scope.row
                                                                .IsForeigner
                                                                ? "外籍"
                                                                : "本籍"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _vm._l(
                                              _vm.scoreType[0],
                                              function (score) {
                                                return _c("el-table-column", {
                                                  key: score.Seq,
                                                  attrs: {
                                                    label: score.Name,
                                                    height: "250",
                                                    align: "center",
                                                    "min-width": "40%",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return _vm._l(
                                                            scope.row.Scores,
                                                            function (item) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key: item.Seq,
                                                                },
                                                                [
                                                                  item.HasOriginScore &&
                                                                  item.Name ===
                                                                    score.Name
                                                                    ? _c(
                                                                        "input",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  item.OriginScore,
                                                                                expression:
                                                                                  "item.OriginScore",
                                                                              },
                                                                            ],
                                                                          staticClass:
                                                                            "form-control text-center",
                                                                          staticStyle:
                                                                            {
                                                                              "background-color":
                                                                                "#dedede",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              type: "number",
                                                                              disabled:
                                                                                "",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                item.OriginScore,
                                                                            },
                                                                          on: {
                                                                            input:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                )
                                                                                  return
                                                                                _vm.$set(
                                                                                  item,
                                                                                  "OriginScore",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  item.Name ===
                                                                  score.Name
                                                                    ? [
                                                                        _c(
                                                                          "ValidationProvider",
                                                                          {
                                                                            staticClass:
                                                                              "w-100",
                                                                            attrs:
                                                                              {
                                                                                name:
                                                                                  scope
                                                                                    .row
                                                                                    .Name +
                                                                                  score.Name,
                                                                                rules:
                                                                                  {
                                                                                    min_value:
                                                                                      item.ScoreLowest,
                                                                                    max_value:
                                                                                      item.ScoreHighest,
                                                                                  },
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "default",
                                                                                    fn: function ({
                                                                                      errors,
                                                                                    }) {
                                                                                      return [
                                                                                        _c(
                                                                                          "input",
                                                                                          {
                                                                                            directives:
                                                                                              [
                                                                                                {
                                                                                                  name: "model",
                                                                                                  rawName:
                                                                                                    "v-model",
                                                                                                  value:
                                                                                                    item.Score,
                                                                                                  expression:
                                                                                                    "item.Score",
                                                                                                },
                                                                                              ],
                                                                                            staticClass:
                                                                                              "form-control text-center",
                                                                                            style:
                                                                                              {
                                                                                                backgroundColor:
                                                                                                  !item.CanWrite
                                                                                                    ? "#dedede"
                                                                                                    : "#ffffff",
                                                                                              },
                                                                                            attrs:
                                                                                              {
                                                                                                type: "text",
                                                                                                disabled:
                                                                                                  !item.CanWrite,
                                                                                              },
                                                                                            domProps:
                                                                                              {
                                                                                                value:
                                                                                                  item.Score,
                                                                                              },
                                                                                            on: {
                                                                                              input:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  if (
                                                                                                    $event
                                                                                                      .target
                                                                                                      .composing
                                                                                                  )
                                                                                                    return
                                                                                                  _vm.$set(
                                                                                                    item,
                                                                                                    "Score",
                                                                                                    $event
                                                                                                      .target
                                                                                                      .value
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          }
                                                                                        ),
                                                                                        errors[0]
                                                                                          ? _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "text-danger",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      errors[0]
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                true
                                                                              ),
                                                                          }
                                                                        ),
                                                                      ]
                                                                    : _vm._e(),
                                                                ],
                                                                2
                                                              )
                                                            }
                                                          )
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                })
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "原因",
                                                rules: "required",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c("textarea", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.trim",
                                                              value:
                                                                _vm
                                                                  .declineInterview
                                                                  .reason,
                                                              expression:
                                                                "declineInterview.reason",
                                                              modifiers: {
                                                                trim: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "text",
                                                            rows: "5",
                                                            placeholder:
                                                              "請輸入原因",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm
                                                                .declineInterview
                                                                .reason,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.$set(
                                                                _vm.declineInterview,
                                                                "reason",
                                                                $event.target.value.trim()
                                                              )
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        errors[0]
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "reset",
                                      "data-dismiss": "modal",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("Buttons.Cancel")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { type: "submit" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("Buttons.Save")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "interviewRecordHistoryModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable",
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("ValidationObserver", {
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ handleSubmit }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-start",
                                  staticStyle: { "margin-bottom": "10px" },
                                },
                                [
                                  _c("ValidationProvider", {
                                    ref: "addInterviewSupervisor",
                                    staticClass: "w-100",
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    multiple: "",
                                                    filterable: "",
                                                    "value-key": "Guid",
                                                    placeholder: "請選擇",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.InterviewSupervisor,
                                                    callback: function ($$v) {
                                                      _vm.InterviewSupervisor =
                                                        $$v
                                                    },
                                                    expression:
                                                      "InterviewSupervisor",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.supervisorOptions,
                                                  function (supervisor) {
                                                    return _c("el-option", {
                                                      key: supervisor.Guid,
                                                      attrs: {
                                                        label: supervisor.Name,
                                                        value: supervisor,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      staticStyle: {
                                        margin: "2px 0 0 10px",
                                        width: "70px",
                                      },
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return handleSubmit(
                                            _vm.addInterviewRecord
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 加簽 ")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c(
                      "div",
                      { staticClass: "evaluation-person-info" },
                      [
                        _c("div", [
                          _c("label", { attrs: { for: "" } }, [_vm._v("姓名")]),
                          _c("div", [
                            _vm._v(_vm._s(_vm.recordList.Interviewee)),
                          ]),
                        ]),
                        _c(
                          "div",
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("面談日期"),
                            ]),
                            _vm._l(
                              _vm.recordList.InterviewDateList,
                              function (date, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$common.dateTimeFormatter(date)
                                      ) +
                                      " "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._l(_vm.recordList.Scores, function (score) {
                          return _c("div", { key: score.Seq }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(score.Name)),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(score.OriginScore) +
                                  "/" +
                                  _vm._s(score.Score)
                              ),
                            ]),
                          ])
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              position: "absolute",
                              right: "5px",
                              bottom: "2px",
                              color: "#ffffff",
                              "z-index": "2",
                              "font-size": "0.9em",
                            },
                          },
                          [
                            _vm._v(
                              " 最後更新者：" +
                                _vm._s(_vm.recordList.UpdateUser) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                    _vm.recordList.InterviewRecords &&
                    _vm.recordList.InterviewRecords.length > 0
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "margin-top": "2px",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "evaluation-body fixed" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-name",
                                      staticStyle: {
                                        height: "60px",
                                        "line-height": "50px",
                                      },
                                    },
                                    [_vm._v(" 單位面試主管 ")]
                                  ),
                                  _vm._l(
                                    _vm.recordList.InterviewRecords[0]
                                      .InterviewRecordAppraisals,
                                    function (item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.Name,
                                          staticClass: "evaluation-field",
                                        },
                                        [_vm._v(" " + _vm._s(item.Name) + " ")]
                                      )
                                    }
                                  ),
                                  _vm.recordList.ResumeType === "IDL"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "evaluation-field" },
                                          [_vm._v("職等")]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-field",
                                      staticStyle: {
                                        height: "150px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [_vm._v(" 面談說明 ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "evaluation-field",
                                      staticStyle: {
                                        height: "150px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [_vm._v(" 個人備註 ")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "evaluation-field" },
                                    [_vm._v("面談結果")]
                                  ),
                                  _c("div", {
                                    staticClass: "evaluation-field",
                                    staticStyle: { height: "42px" },
                                  }),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    flex: "1",
                                    "min-width": "1px",
                                  },
                                },
                                [
                                  _c(
                                    "carousel",
                                    {
                                      key: Math.random(),
                                      attrs: {
                                        items:
                                          _vm.recordList.InterviewRecords
                                            .length,
                                        nav: true,
                                        dots: false,
                                      },
                                    },
                                    _vm._l(
                                      _vm.recordList.InterviewRecords,
                                      function (record) {
                                        return _c(
                                          "div",
                                          {
                                            key: record.InterviewSupervisorId,
                                            staticClass: "evaluation-body",
                                            on: {
                                              dblclick: function ($event) {
                                                return _vm.$common.copyText(
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-name",
                                                staticStyle: { height: "60px" },
                                              },
                                              [
                                                _vm._v(
                                                  " 【" +
                                                    _vm._s(
                                                      record.InterviewTitle
                                                    ) +
                                                    "】"
                                                ),
                                                _c("br"),
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      effect: "dark",
                                                      content:
                                                        record.InterviewSupervisor +
                                                        " (" +
                                                        record.InterviewUserType +
                                                        ")",
                                                      placement: "right",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record.InterviewSupervisor
                                                          ) +
                                                          " (" +
                                                          _vm._s(
                                                            record.InterviewUserType
                                                          ) +
                                                          ") "
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._l(
                                              record.InterviewRecordAppraisals,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.Name,
                                                    staticClass:
                                                      "evaluation-field",
                                                  },
                                                  [
                                                    item.Result !== "-" &&
                                                    item.Result !== "未填寫"
                                                      ? [
                                                          item.Remark
                                                            ? _c(
                                                                "el-tooltip",
                                                                {
                                                                  staticClass:
                                                                    "item",
                                                                  attrs: {
                                                                    effect:
                                                                      "dark",
                                                                    content:
                                                                      item.Remark,
                                                                    placement:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.Result
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.Result
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.Result)
                                                          ),
                                                        ]),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            _vm.recordList.ResumeType === "IDL"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "evaluation-field",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record.ExpectedJobLevel
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: {
                                                  height: "150px",
                                                  "overflow-y": "auto",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(record.Remark) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: {
                                                  height: "150px",
                                                  "overflow-y": "auto",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.PersonalRemark
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.InterviewResult
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "evaluation-field",
                                                staticStyle: { height: "42px" },
                                              },
                                              [
                                                record.InterviewResult ===
                                                "未填寫"
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-warning btn-sm",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.interviewRecordUrge(
                                                              record.InterviewSupervisorId
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" 催辦 ")]
                                                    )
                                                  : _c("div", [
                                                      _vm._v("已填寫面談紀錄"),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(" 關閉 ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        "data-toggle": "modal",
                        "data-target": "#interviewEvaluationModal",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.getApproveInterview(_vm.recordList)
                        },
                      },
                    },
                    [_vm._v(" 完成面談評估 ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _c("EvaluateInterviewModal", {
        attrs: {
          Source: "Interviewed",
          AdmitOptions: _vm.admitOptions,
          IdlRejectOptions: _vm.idlRejectOptions,
          DlRejectOptions: _vm.dlRejectOptions,
          Person: _vm.personData,
        },
        on: { saveApproveInterview: _vm.saveApproveInterview },
      }),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 0
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 0
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("履歷")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "item text-right" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$common.downloadResumePDF(
                                                      _vm.ResumeType,
                                                      _vm.ResumeId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 下載 PDF ")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.ResumeType === "IDL"
                                      ? _c("IdlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.ResumeType === "DL"
                                      ? _c("DlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("ProgressRecordModal", {
        attrs: { Name: _vm.Name, UserId: _vm.UserId, Email: _vm.Email },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", [_vm._v("面談紀錄歷程")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }